import React from "react";
import { motion } from "framer-motion";

const cardVariants = {
	hidden: { opacity: 0, y: 40 },
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			duration: 0.6,
			ease: "easeOut",
		},
	},
};

export default function ServicesCard({ icon: Icon, title, description }) {
	return (
		<motion.div
			variants={cardVariants}
			className="bg-white rounded-3xl p-10 shadow-xl ring-1 ring-gray-100 flex flex-col items-center text-center hover:shadow-xl transition-all duration-300"
		>
			<Icon className="text-[#cbbca3] text-5xl mb-6" />

			<h3 className="text-[#0a1633] text-xl font-semibold uppercase mb-4">
				{title}
			</h3>
			<p className="text-gray-600 leading-relaxed text-sm">{description}</p>
		</motion.div>
	);
}
